/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, ReactNode } from "react";
import Link from "@wff/components/Link";
import classes from "./NavLink.module.scss";

interface Props {
  prefetch?: boolean;
  passHref?: boolean;
  href?: string;
  onClick?: () => void;
  children: ReactNode;
  className?: string;
}

export const NavLink: FC<Props> = ({
  prefetch,
  passHref,
  href,
  children,
  onClick,
  className,
}) => {
  return href ? (
    <Link
      href={typeof href === "string" ? href : ""}
      passHref={Boolean(href) && passHref}
      prefetch={prefetch}
    >
      <a className={`${classes["nav-link"]} ${className}`}>{children}</a>
    </Link>
  ) : (
    <a className={`${classes["nav-link"]} ${className}`} onClick={onClick}>
      {children}
    </a>
  );
};

NavLink.defaultProps = {
  prefetch: false,
  passHref: true,
  href: undefined,
};
